"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _iconInformationFillExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-information-fill-extra-small"));
var _layout = require("../../layout");
var _text = require("../../text");
var _tooltip = require("../../tooltip");
var _utils2 = require("../../utils");
var _constants = require("./constants");
var _helperComponents = require("./helperComponents");
var _propTypes = require("./propTypes");
var _react2 = require("@emotion/react");
const Tooltip = (0, _tooltip.withTooltip)({
  triggerVerticalAlign: 'middle'
})(_iconInformationFillExtraSmall.default);
const InputHeaderBase = _ref => {
  let {
    descriptionId,
    descriptionText,
    error = _constants.inputHeaderDefaultProps.error,
    htmlFor,
    labelId,
    labelText,
    renderLabel = _constants.inputHeaderDefaultProps.renderLabel,
    required = _constants.inputHeaderDefaultProps.required,
    tooltipAlignment,
    tooltipAltText = _constants.inputHeaderDefaultProps.tooltipAltText,
    tooltipText,
    warning = _constants.inputHeaderDefaultProps.warning,
    ...forwardedProps
  } = _ref;
  const hasTooltip = tooltipText !== undefined;
  let labelColor = _utils2.LABEL_COLOR;
  let asteriskColor = _utils2.LABEL_ASTERISK_COLOR;
  if (error) {
    labelColor = _utils2.LABEL_ERROR_COLOR;
    asteriskColor = _utils2.LABEL_ERROR_COLOR;
  } else if (warning) {
    labelColor = _utils2.LABEL_WARNING_COLOR;
    asteriskColor = _utils2.LABEL_WARNING_COLOR;
  }
  return (0, _react2.jsx)(_layout.Col, {
    gridGap: "S100"
  }, (0, _react2.jsx)(_helperComponents.InputHeaderView, (0, _extends2.default)({
    display: "inline"
  }, (0, _utils2.pickDataProps)(forwardedProps)), renderLabel({
    htmlFor,
    labelId,
    color: labelColor,
    children: (0, _react2.jsx)(_layout.View, {
      display: "inline",
      minHeight: _utils2.A11Y_INLINE_MIN_SIZE,
      margin: hasTooltip ? {
        right: _utils2.TOOLTIP_HORIZONTAL_SPACING
      } : undefined
    }, labelText, required && (0, _react2.jsx)(_helperComponents.Asterisk, {
      color: asteriskColor
    }))
  }), hasTooltip && (0, _react2.jsx)(Tooltip, {
    color: _utils2.TOOLTIP_COLOR,
    isInline: false,
    title: tooltipAltText,
    tooltipText: tooltipText,
    tooltipAlignment: tooltipAlignment
  })), descriptionText && (0, _react2.jsx)(_text.Text, {
    id: descriptionId,
    variant: _text.TextVariant.BodySM,
    color: (0, _utils.token)('color.text.secondary')
  }, descriptionText));
};
const InputHeaderWithDocs = (0, _stencilReactDesc.describe)(InputHeaderBase).description('Header for form elements that displays a label.');
InputHeaderWithDocs.propTypes = {
  ..._propTypes.inputHeaderPropTypes
};
const InputHeader = (0, _utils2.withTestAttributes)({
  component: 'StencilReactInputHeader'
})(InputHeaderWithDocs);
InputHeader.defaultProps = {
  ..._constants.inputHeaderDefaultProps
};
InputHeader.displayName = 'InputHeader';
var _default = exports.default = InputHeader;